var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvnios({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 1.58333H12.35C12 0.665 11.0833 0 10 0C8.91667 0 8 0.665 7.65 1.58333H4.16667C3.25 1.58333 2.5 2.29583 2.5 3.16667V15.8333C2.5 16.7042 3.25 17.4167 4.16667 17.4167H15.8333C16.75 17.4167 17.5 16.7042 17.5 15.8333V3.16667C17.5 2.29583 16.75 1.58333 15.8333 1.58333ZM10 1.58333C10.4583 1.58333 10.8333 1.93958 10.8333 2.375C10.8333 2.81042 10.4583 3.16667 10 3.16667C9.54167 3.16667 9.16667 2.81042 9.16667 2.375C9.16667 1.93958 9.54167 1.58333 10 1.58333ZM15.8333 15.8333H4.16667V3.16667H5.83333V5.54167H14.1667V3.16667H15.8333V15.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvnios);
export default __webpack_public_path__ + "static/media/Convênios.096d47f07554d571e984f63a464e8556.svg";
export { ForwardRef as ReactComponent };